<template>
  <div id="video-test">
    <!-- <div>video</div> -->
    <!-- <video :src="url" x5-video-orientation= 'landscape' preload="auto" x-webkit-airplay="true" x5-playsinline="true" webkit-playsinline="true" playsinline="true" controls='controls' class="video-box"></video> -->
    <!-- <video ref="fullVideoRef" webkit-playsinline  playsinline v-if="isFull" :src="url" x5-video-orientation= 'landscape' preload="auto" controls='controls' class="video-box"></video> -->
    <div class="my-video-wrapper">
      <div class="play-wrapper" id="videoPlay" @click="goplay"></div>
      <div class="full-wrapper" @click="goFull"></div>
      <div id="wrapper">
      </div>
    </div>
    <!-- <van-button type='primary' @click="goFull">点我全屏</van-button>
    <van-button type='primary' @click="goplay">点我播放</van-button> -->
  </div>
</template>

<script>
// import ChimeePlayer from 'chimee-player'
// import ChimeeMobilePlayer from 'chimee-mobile-player'
// import '../../node_modules/_chimee-mobile-player@0.2.8@chimee-mobile-player/lib/chimee-mobile-player.browser.css'
export default {
  data () {
    return {
      url: null,
      bgcImg: null,
      Chimee: null,
      isFull: false,
      tcplayer: null,
      videoInit: null
    }
  },
  watch: {
  },
  props: {
    itemId: {},
    itemName: {
      type: String,
      default:''
    }
  },
  mounted () {
    // this.setUrl()
    //this.getVideoPlayCount()
    this.fetch()
  },
  beforeDestroy() {
    if( this.tcplayer.video.playState == 'PLAYING' ) {
      localStorage.setItem("video-" + this.itemId , this.tcplayer.currentTime() )
    }
  },
  methods: {
    resetVideo(url, coverUrl) {
      this.url = url 
      this.bgcImg = coverUrl
      if( this.tcplayer ) {
          this.tcplayer.destroy()
      }
      this.initTcPlayer()
    },
    // 统计视频播放量
    getVideoPlayCount() {
      var _hmt = _hmt || [];
      (function() {
        var hm = document.createElement("script");
        hm.src = "https://hm.baidu.com/hm.js?d71fba110fd6a1074faf2e0e10638427";
        var s = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(hm, s);
      })();
    },
    setUrl () {
      this.url = 'https://video.shendutv.com/d0471ef3e4be4e2f9c042de13556e4d0/1bee4e6e30a44f639876d75913aca745-b9b90ff2d185429e65e7f67fb5cfc3e9-ld.mp4'
    },
    videoPlay() {
      this.tcplayer.play()
    },
    initTcPlayer () {
      let _this = this
      // this.fetch()
      // eslint-disable-next-line
      this.tcplayer =  new TcPlayer('wrapper', {
        // 'mp4': 'https://video.shendutv.com/d0471ef3e4be4e2f9c042de13556e4d0/1bee4e6e30a44f639876d75913aca745-b9b90ff2d185429e65e7f67fb5cfc3e9-ld.mp4', // 请替换成实际可用的播放地址
        'mp4': _this.url, // 请替换成实际可用的播放地址
        // 'autoplay': true, // iOS下safari浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
        'coverpic': {
          'style': 'default',
          'src': _this.bgcImg
        },
        // "autoplay" : true, // iOS 下 safari 浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
        'width': '100%', // 视频的显示宽度，请尽量使用视频分辨率宽度
        'height': '100%', // 视频的显示高度，请尽量使用视频分辨率高度
        'controls': 'default',
        'x5_player': true,
        'x5_playsinline': 'true',
        listener: (msg)=>{          
          var video =  document.getElementsByTagName('video')[0]             
          if(!video.getAttribute('id')) {
            video.setAttribute('id', 'videoPlay')    
          }              
          if(msg.type == 'loadedmetadata' ) {
            this.setCutDownPlay(msg)
            
          } 
          else if( msg.type == 'pause' || msg.type == 'seeked' ) { // 暂停或者拖动 记录播放位置
            localStorage.setItem("video-" + this.itemId , this.tcplayer.currentTime() )
            window._hmt.push(['_trackEvent', 'video', msg.type, this.itemName]);
          }
          else if( msg.type == 'play') {
            window._hmt.push(['_trackEvent', 'video', 'play', this.itemName]);
            this.$emit('videoplay')
              let lastPlayTime = localStorage.getItem('video-' + this.itemId ) 
              if( lastPlayTime ) {
                //this.$toast("已为你自动定位上次观看位置")
              }
          }
          else if( msg.type == 'ended' ) {
            window._hmt.push(['_trackEvent', 'video', 'end', this.itemName]);
            localStorage.removeItem("video-" + this.itemId)
            this.$emit('videoended') 
          }
          //console.log("currentTime", this.tcplayer.currentTime())
        }
        // 'x5_type': 'h5',
        // 'preload': true
      })
      // eslint-disable-next-line
    },
    setCutDownPlay(video) {
      let lastPlayTime = localStorage.getItem('video-' + this.itemId ) 
      // 当前帧加载      
        console.log("setTimeout ")
      if( lastPlayTime ) {
        this.tcplayer.currentTime(lastPlayTime)  
      }  
        
    },
    goFull () {
      if (this.tcplayer.playing()) {
        this.tcplayer.pause()
      }
      // let ref = this.$refs.fullVideoRef
      let video = document.querySelector('video')
      video.removeAttribute('webkit-playsinline')
      video.removeAttribute('playsinline')
      // eslint-disable-next-line
      let timeOut = setTimeout(() => {
        this.tcplayer.play()
        this.FullScreen()
      }, 100)
    },
    goplay () {
      let video = document.querySelector('video')
      video.setAttribute('webkit-playsinline', '')
      video.setAttribute('playsinline', '')
      // eslint-disable-next-line
      let timeOut = setTimeout(() => {
        this.tcplayer.togglePlay()
      }, 100)
    },
    // 进入全屏
    FullScreen () {
      var ele = document.documentElement
      if (ele.requestFullscreen) {
        ele.requestFullscreen()
      } else if (ele.mozRequestFullScreen) {
        ele.mozRequestFullScreen()
      } else if (ele.webkitRequestFullScreen) {
        ele.webkitRequestFullScreen()
      }
    },
    // 退出全屏
    exitFullscreen () {
      var de = document
      if (de.exitFullscreen) {
        de.exitFullscreen()
      } else if (de.mozCancelFullScreen) {
        de.mozCancelFullScreen()
      } else if (de.webkitCancelFullScreen) {
        de.webkitCancelFullScreen()
      }
    },
    // 判断是否全屏
    isFullScreen () {
      // alert(document.isFullScreen || document.mozIsFullScreen || document.webkitIsFullScreen)
      return document.isFullScreen || document.mozIsFullScreen || document.webkitIsFullScreen
    },
    // 重写全屏
    videoFull () {
      let bindFull = document.querySelector('.vcp-fullscreen-toggle')
      bindFull.addEventListener('click', () => {
        this.goFull()
      })
    },
    // 获取数据
    fetch () {
      let params = {
        item_id: this.itemId
      }
      let url = `home/video_detail?item_id=${params.item_id}`
      this.$http.get(url).then(res => {
        if (res.data.code == 0) {
          this.bgcImg = res.data.data.aliyun_cover_url
          this.url = res.data.data.aliyun_mp4_play_url
          this.testId = this.itemId
          this.$nextTick(() => {
            this.initTcPlayer()
          })
        }
      })
    }
  }
}

</script>

<style lang="postcss">
#video-test{
  & .video-box{
    height: 422px;
    width: 100%;
  }
  & .my-video-wrapper {
    height: 422px;
    width: 100%;
    position: relative;    
    & #wrapper{
      height: 422px;
      & .vcp-player {
        height: 422px;
      }
    }
  }
  & .play-wrapper{
    height: 90px;
    width: 100px;
    /* background-color: red; */
    position: absolute;
    bottom: 0;
    z-index: 999;
  }
  & .full-wrapper{
    height: 90px;
    width: 100px;
    /* background-color: red; */
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: 999;
  }
  & .vcp-poster-pic{
    width: 100%;
    height: 100%;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/public/TcPlayer.vue